import React, { useState } from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { useAppState } from "src/app/state/StateProvider";
import useValidationSchemaContactService, { ContactServiceFormData } from "src/pages/contactservice/useValidationSchemaContactService";
import { sendContactServiceForAffilie, sendContactServiceForUser } from "src/app/api/ContactServiceApi";
import { useAppText } from "src/commun/composants/AppText";
import ContactServiceFormContent from "src/pages/contactservice/ContactServiceFormContent";
import AppCol from "src/commun/composants/grille/AppCol";
import styles from "src/pages/contactservice/ContactService.scss";

const ContactServiceForm = () => {
  const [{ user, employeurContextuel, langue }] = useAppState();
  const { tString } = useAppText();
  const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);
  const validationSchema = useValidationSchemaContactService();

  const initialValues = {
    codeService: "",
    message: "",
  } as ContactServiceFormData;

  const submitSuccessHandler = () => {
    setSubmitSuccess(true);
  };

  const submitHandler = (values: ContactServiceFormData) => {
    if (user?.comptePersonnel) {
      return sendContactServiceForUser({ ...values, locale: langue, agence: "CIAM" });
    } else {
      return sendContactServiceForAffilie(employeurContextuel!.uuidEmployeur, { ...values, locale: langue, nomAffilie: employeurContextuel!.nomEmployeur, agence: employeurContextuel!.agence});
    }
  };

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={submitHandler}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
    >
      <AppCol md={{ span: 11 }} className={styles.container}>
        {!submitSuccess &&
          <ContactServiceFormContent/>
        }
        {submitSuccess &&
          <>
            <div className="input mt-5 mb-5 {styles.title}">
              <h3> {tString("contactservice.confirmatiom.titre")}</h3>
            </div>
            <div className="input mt-5 mb-5 {styles.title}">
              {tString("contactservice.confirmatiom.message")}
            </div>
          </>
        }
      </AppCol>
    </AppFormik>
  );
};

export default ContactServiceForm;